export default "__VITE_ASSET__QHKQ503G__"